import RegistrationPage from './registration';

export default RegistrationPage;
